// REACT & Libraries
import { useEffect } from "react";
import { useAppSelector } from "../../../ReduxToolkit/Hooks";

// Role Guard
import RoleGuard from "../../RoleGuard";

// Components
import RegionsContainer from "../../../Components/MasterData/Regions";

const Regions = () => {
  const { user } = useAppSelector((state) => state.auth);
  const currentUserRoles = user?.roles?.map((role) => role.slug) || [];
  useEffect(() => {
    document.title = "Regions Master Data";
  }, []);

  return (
    <>
      {/* RoleGuard ensures only allowed roles can view the page */}
      <RoleGuard
        userRoles={currentUserRoles}
        allowedRoles={["admin", "data-master"]}
      />

      {/* Main content */}
      <RegionsContainer />
    </>
  );
};

export default Regions;
